import request from '@/utils/request';
//列表
export function groupList(data) {
  return request.post('admin/template/group/list', data);
}
//状态
export function templateGroupStatus(data) {
  return request.post('admin/template/group/status', data);
}
//删除
export function delTemplateGroup(data) {
  return request.post('admin/template/group/delete', data);
}
//状态之前的查询
export function templateGroupStatusInfo(data) {
  return request.post('admin/template/group/status/info', data);
}
//详情
export function templateGroupDetail(data) {
  return request.post('admin/template/group/detail', data);
}
//新增
export function addtTemplateGroup(data) {
  return request.post('admin/template/group/store', data);
}
//编辑
export function editTemplateGroup(data) {
  return request.post('admin/template/group/edit', data);
}
//资源
export function templateGroupResources(data) {
  return request.post('admin/customer-insurance/template-group', data);
}